import React, { useState } from 'react';

const CookieConsent = () => {
  const [show, setShow] = useState(true);

  const handleConsent = (consent: boolean) => {
    setShow(false);
    // You can add logic here to store the user's preference
    console.log('Cookie consent:', consent);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6">
      <div className="container-lg">
        {/* Glow effect */}
        <div className="absolute inset-0 mx-4 md:mx-6 bg-gradient-to-r from-primary-500/20 via-accent-purple/20 to-accent-cyan/20 rounded-3xl blur-xl" />

        <div className="relative glass-dark rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6 border border-dark-700/50">
          {/* Cookie icon */}
          <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-primary-500 to-accent-purple rounded-2xl flex items-center justify-center shadow-glow-sm">
            <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          {/* Text content */}
          <div className="flex-grow">
            <p className="text-white text-lg font-semibold mb-1">
              We use cookies to enhance your experience
            </p>
            <p className="text-dark-400">
              By continuing to browse, you agree to our use of cookies.{' '}
              <a href="/privacy" className="text-primary-400 hover:text-primary-300 underline underline-offset-2 transition-colors">
                Learn more
              </a>
            </p>
          </div>

          {/* Buttons */}
          <div className="flex gap-3 w-full md:w-auto">
            <button
              onClick={() => handleConsent(false)}
              className="flex-1 md:flex-none px-6 py-3 text-sm font-semibold text-dark-300 bg-dark-800 border border-dark-700 rounded-xl hover:bg-dark-700 hover:text-white transition-all duration-300"
            >
              Decline
            </button>
            <button
              onClick={() => handleConsent(true)}
              className="flex-1 md:flex-none px-6 py-3 text-sm font-semibold text-white bg-gradient-to-r from-primary-500 to-accent-purple rounded-xl hover:shadow-glow transition-all duration-300 hover:scale-[1.02]"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
